"use client";

import AnimatedOwl from "./_components/AnimatedOwl";
import LeftComponent from "./_components/LeftComponent";
import Footer from "./_components/Footer";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useProfileContext } from "../../context/ProfileContext";

const SketchieOwlApp = () => {
  const { selectedProfile } = useProfileContext();
  const router = useNavigate();

  // If someone lands on /home without being logged in, redirect to login
  useEffect(() => {
    if (!selectedProfile) {
      router("/", { replace: true });
    } else {
      router("/profile", { replace: true });
    }
  }, [selectedProfile, router]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-300 via-pink-200 to-yellow-200 overflow-hidden relative">
      <div className="container mx-auto px-4 py-8 relative z-10">
        <AnimatedOwl />
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <LeftComponent />
          <div className="space-y-8">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SketchieOwlApp;
